import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

const NotFound = lazy(() => import("../../container/pages/404"));
const SubscriptionPackagesList = lazy(() =>
  import("../../container/subscriptionPackages/SubscriptionPackagesList")
);
const AddPackage = lazy(() =>
  import("../../container/subscriptionPackages/components/createBranchForm")
);

function IconsRoute() {
  return (
    <Routes>
      <Route path="/" element={<SubscriptionPackagesList />} />
      <Route path="/add-subscription-package" element={<AddPackage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default IconsRoute;
